const SectionType = Object.freeze({
  HERO: 'hero',
  HERO_V2: 'hero_v2',
  HERO_V3: 'hero_v3',
  INSURANCES: 'insurances',
  OUR_SERVICE: 'our_service',
  QUALITY_CARE: 'quality_care',
  HOW_IT_WORKS: 'how_it_works',
  SLEEP_DISORDERS: 'sleep_disorders',
  GET_TESTED: 'get_tested',
  CARE_TEAM: 'care_team',
  REVIEWS: 'reviews',
  PRESS: 'press',
  BLOG: 'blog',
  FAQ: 'faq',
  REFER: 'refer',
});

export default SectionType;
